import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { toast } from "react-toastify";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import BasicBtn from "../../../component/atoms/button/basicBtn";
import MainInput from "../../../component/atoms/input/mainInput";
import Checkbox from "../../../component/atoms/input/checkbox";
import DateInput from "../../../component/atoms/input/dateInput";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import TicketPromotionApi from "../../../api/ticketPromotion.api";
import moment from "moment";
import { route } from "../../../router/route";

const ShoppingMembershipProductEdit = () => {
  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_membership_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const navigate = useNavigate();
  const { id } = useParams();

  const [title, setTitle] = useState("");
  const [accentTitle, setAccentTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [noPeriodLimit, setNoPeriodLimit] = useState(false);

  const [monthPrice, setMonthPrice] = useState(0);
  const [monthIsSale, setMonthIsSale] = useState(false);
  const [monthSale, setMonthSale] = useState(0);
  const [monthStock, setMonthStock] = useState(0);
  const [monthOutStock, setMonthOutStock] = useState(false);
  const [monthRealPrice, setMonthRealPrice] = useState("");

  useEffect(() => {
    if (Number(monthPrice) > 0) {
      if (monthIsSale) {
        let temp =
          Number(monthPrice) - Number(monthPrice) * (Number(monthSale) / 100);

        setMonthRealPrice(temp);
      } else {
        setMonthRealPrice(monthPrice);
      }
    }
  }, [monthPrice, monthIsSale, monthSale]);

  useEffect(() => {
    if (!monthIsSale) {
      setMonthSale(0);
    }
  }, [monthIsSale]);

  const [annualPrice, setAnnualPrice] = useState("");
  const [annualIsSale, setAnnualIsSale] = useState(false);
  const [annualSale, setAnnualSale] = useState("");
  const [annualStock, setAnnualStock] = useState("");
  const [annualOutStock, setAnnualOutStock] = useState(false);
  const [annualRealPrice, setAnnualRealPrice] = useState("");
  const [annualMonthPrice, setAnnualMonthPrice] = useState("");

  useEffect(() => {
    if (Number(annualPrice) > 0) {
      if (annualIsSale) {
        let temp =
          Number(annualPrice) -
          Number(annualPrice) * (Number(annualSale) / 100);

        setAnnualRealPrice(temp);
        setAnnualMonthPrice(Number(Number(temp) / 12).toFixed(0));
      } else {
        setAnnualRealPrice(annualPrice);
        setAnnualMonthPrice(Number(Number(annualPrice) / 12).toFixed(0));
      }
    }
  }, [annualPrice, annualIsSale, annualSale]);

  useEffect(() => {
    if (!annualIsSale) {
      setAnnualSale(0);
    }
  }, [annualIsSale]);

  const [lifetimePrice, setLifetimePrice] = useState("");
  const [lifetimeIsSale, setLifetimeIsSale] = useState(false);
  const [lifetimeSale, setLifetimeSale] = useState("");
  const [lifetimeStock, setLifetimeStock] = useState("");
  const [lifetimeOutStock, setLifetimeOutStock] = useState(false);
  const [lifetimeRealPrice, setLifetimeRealPrice] = useState("");
  const [lifetimeMonthPrice, setLifetimeMonthPrice] = useState("");

  useEffect(() => {
    if (Number(lifetimePrice) > 0) {
      if (lifetimeIsSale) {
        let temp =
          Number(lifetimePrice) -
          Number(lifetimePrice) * (Number(lifetimeSale) / 100);

        setLifetimeRealPrice(temp);
        setLifetimeMonthPrice(Number(Number(temp) / 12).toFixed(0));
      } else {
        setLifetimeRealPrice(lifetimePrice);
        setLifetimeMonthPrice(Number(Number(lifetimePrice) / 12).toFixed(0));
      }
    }
  }, [lifetimePrice, lifetimeIsSale, lifetimeSale]);

  useEffect(() => {
    if (!lifetimeIsSale) {
      setLifetimeSale(0);
    }
  }, [lifetimeIsSale]);

  function isNumericString(str) {
    const regex = /^\d+$/;
    return regex.test(str);
  }

  useEffect(() => {
    getInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getInfo = async () => {
    try {
      const response = (await TicketPromotionApi.getById(id)).data.data.content;
      setTitle(response.title);
      setAccentTitle(response.accentTitle);
      setStartDate(response.startDate);
      setEndDate(response.endDate);

      setNoPeriodLimit(
        moment(response.endDate).format("YYYY-MM-DD") === "9999-12-31"
          ? true
          : response.endDate
          ? false
          : true
      );

      setMonthPrice(response?.monthTicket?.price || 0);
      setMonthIsSale(
        response?.monthTicket?.discountPercent === 0 ? false : true
      );
      setMonthSale(response?.monthTicket?.discountPercent || 0);
      setMonthStock(response?.monthTicket?.stock || 0);
      setMonthOutStock(response?.monthTicket?.stock === 0 ? true : false);
      setMonthRealPrice(response?.monthTicket?.price || 0);

      setAnnualPrice(response.annualTicket.price);
      setAnnualIsSale(
        response.annualTicket.discountPercent === 0 ? false : true
      );
      setAnnualSale(response.annualTicket.discountPercent);
      setAnnualStock(response.annualTicket.stock);
      setAnnualOutStock(response.annualTicket.stock === 0 ? true : false);

      setLifetimePrice(response.lifetimeTicket.price);
      setLifetimeIsSale(
        response.lifetimeTicket.discountPercent === 0 ? false : true
      );
      setLifetimeSale(response.lifetimeTicket.discountPercent);
      setLifetimeStock(response.lifetimeTicket.stock);
      setLifetimeOutStock(response.lifetimeTicket.stock === 0 ? true : false);
    } catch (error) {
      errorHandler(error);
    }
  };

  const editProductFunc = async (type) => {
    try {
      if (title === "") {
        return toast("프로모션명을 입력해주세요.");
      }

      if (monthPrice === "") {
        return toast("월간 수강권 가격을 입력해주세요.");
      }

      if (annualPrice === "") {
        return toast("1년 수강권 가격을 입력해주세요.");
      }

      if (lifetimePrice === "") {
        return toast("평생 수강권 가격을 입력해주세요.");
      }

      if (
        !isNumericString(String(monthPrice)) ||
        !isNumericString(String(monthSale)) ||
        !isNumericString(String(monthStock)) ||
        !isNumericString(String(annualPrice)) ||
        !isNumericString(String(annualSale)) ||
        !isNumericString(String(annualStock)) ||
        !isNumericString(String(lifetimePrice)) ||
        !isNumericString(String(lifetimeSale)) ||
        !isNumericString(String(lifetimeStock))
      ) {
        return toast("숫자만 입력가능합니다");
      }

      if (startDate === "") {
        return toast("시작 기간을 선택해주세요.");
      }

      if (!noPeriodLimit && !endDate) {
        return toast("종료 기간을 선택해주세요.");
      }

      const data = {
        monthTicket: {
          price: Number(monthPrice),
          discountPercent: Number(monthSale),
          stock: monthOutStock ? 0 : Number(monthStock),
        },
        annualTicket: {
          price: Number(annualPrice),
          discountPercent: Number(annualSale),
          stock: annualOutStock ? 0 : Number(annualStock),
        },
        lifetimeTicket: {
          price: Number(lifetimePrice),
          discountPercent: Number(lifetimeSale),
          stock: lifetimeOutStock ? 0 : Number(lifetimeStock),
        },
        title: title,
        accentTitle: accentTitle,
        startDate: moment(startDate).format("YYYY-MM-DD"),
        endDate: noPeriodLimit ? null : moment(endDate).format("YYYY-MM-DD"),
      };

      await TicketPromotionApi.update(id, data);

      toast(toastMsg.create);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 24,
            }}
          >
            상품 편집 및 추가
          </TableTitle>

          <SettingContainer>
            {/* 프로모션명 */}
            <ProductItemWrapper>
              <ProductItemTitle>프로모션명</ProductItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <MainInput
                    type={"text"}
                    placeholder={"강조문구(생략가능)"}
                    style={{
                      width: "338px",
                    }}
                    value={accentTitle}
                    onChange={(e) => {
                      setAccentTitle(e.target.value);
                    }}
                  />
                  <MainInput
                    type={"text"}
                    placeholder={"프로모션명"}
                    style={{
                      width: "338px",
                    }}
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                  />
                </div>
                <PretendardText
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                    marginTop: "12px",
                  }}
                >
                  강조문구는 출력 시 파란 글씨로 강조됩니다 ex. [기간한정],
                  [파격할인], [선착순 혜택] 등
                </PretendardText>
              </div>
            </ProductItemWrapper>

            {/* 월간 수강권 가격 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                padding: "21px 0px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                }}
              >
                <ProductItemTitle>월간 수강권 가격</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <MainInput
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "338px",
                      textAlign: "right",
                    }}
                    value={monthPrice}
                    onChange={(e) => {
                      setMonthPrice(e.target.value);
                    }}
                  />

                  <CheckboxWrapper
                    style={{
                      margin: "12px 0px",
                    }}
                    onClick={() => {
                      setMonthIsSale(!monthIsSale);
                    }}
                  >
                    <Checkbox
                      style={{
                        backgroundColor: "transparent",
                      }}
                      checked={monthIsSale}
                      onChange={() => {
                        setMonthIsSale(!monthIsSale);
                      }}
                    />
                    <CheckboxText>할인 사용</CheckboxText>
                  </CheckboxWrapper>
                </div>
              </div>

              {/* 할인율 */}
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                  marginTop: 19,
                }}
              >
                <ProductItemTitle>할인율</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <MainInput
                    disabled={!monthIsSale}
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "93px",
                      textAlign: "right",
                    }}
                    value={monthSale}
                    onChange={(e) => {
                      setMonthSale(e.target.value);
                    }}
                    maxLength={3}
                  />
                  <ProductItemTitle
                    style={{
                      width: "fit-content",
                      marginTop: 0,
                    }}
                  >
                    %
                  </ProductItemTitle>
                </div>
              </div>

              {/* 실 판매 가격 */}
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                  marginTop: 19,
                }}
              >
                <ProductItemTitle>실 판매 가격</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  <MainInput
                    type={"text"}
                    disabled={true}
                    placeholder={"0"}
                    style={{
                      width: "338px",
                      textAlign: "right",
                    }}
                    value={monthRealPrice}
                    onChange={(e) => {}}
                  />

                  <MainInput
                    type={"text"}
                    placeholder={"발급수량(최대 500개)"}
                    style={{
                      width: "338px",
                    }}
                    value={monthStock}
                    onChange={(e) => {
                      setMonthStock(e.target.value);
                    }}
                    maxLength={3}
                  />
                  <CheckboxWrapper
                    onClick={() => {
                      setMonthOutStock(!monthOutStock);
                    }}
                  >
                    <Checkbox
                      style={{
                        backgroundColor: "transparent",
                      }}
                      checked={monthOutStock}
                      onChange={() => {
                        setMonthOutStock(!monthOutStock);
                      }}
                    />
                    <CheckboxText>품절 처리</CheckboxText>
                  </CheckboxWrapper>
                </div>
              </div>
            </div>

            {/* 1년 수강권 가격 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                padding: "21px 0px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                }}
              >
                <ProductItemTitle>1년 수강권 가격</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <MainInput
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "338px",
                      textAlign: "right",
                    }}
                    value={annualPrice}
                    onChange={(e) => {
                      setAnnualPrice(e.target.value);
                    }}
                  />

                  <CheckboxWrapper
                    style={{
                      margin: "12px 0px",
                    }}
                    onClick={() => {
                      setAnnualIsSale(!annualIsSale);
                    }}
                  >
                    <Checkbox
                      style={{
                        backgroundColor: "transparent",
                      }}
                      checked={annualIsSale}
                      onChange={() => {
                        setAnnualIsSale(!annualIsSale);
                      }}
                    />
                    <CheckboxText>할인 사용</CheckboxText>
                  </CheckboxWrapper>
                </div>
              </div>

              {/* 할인율 */}
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                  marginTop: 19,
                }}
              >
                <ProductItemTitle>할인율</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <MainInput
                    disabled={!annualIsSale}
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "93px",
                      textAlign: "right",
                    }}
                    value={annualSale}
                    onChange={(e) => {
                      setAnnualSale(e.target.value);
                    }}
                    maxLength={3}
                  />
                  <ProductItemTitle
                    style={{
                      width: "fit-content",
                      marginTop: 0,
                    }}
                  >
                    %
                  </ProductItemTitle>
                </div>
              </div>

              {/* 실 판매 가격 */}
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                  marginTop: 19,
                }}
              >
                <ProductItemTitle>실 판매 가격</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <MainInput
                      type={"text"}
                      disabled={true}
                      placeholder={"0"}
                      style={{
                        width: "338px",
                        textAlign: "right",
                      }}
                      value={annualRealPrice}
                      onChange={(e) => {}}
                    />
                    <div
                      style={{
                        width: 12,
                      }}
                    />
                    <ProductItemTitle
                      style={{
                        width: "fit-content",
                        marginTop: 0,
                      }}
                    >
                      월
                    </ProductItemTitle>

                    <MainInput
                      type={"text"}
                      disabled={true}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={annualMonthPrice}
                      onChange={(e) => {}}
                    />
                    <ProductItemTitle
                      style={{
                        width: "fit-content",
                        marginTop: 0,
                      }}
                    >
                      원
                    </ProductItemTitle>
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: "13px",
                        lineHeight: "18.75px",
                        color: "rgba(181, 181, 181, 0.5)",
                        marginLeft: "4px",
                      }}
                    >
                      *실 판매금액/12개월
                    </PretendardText>
                  </div>

                  <MainInput
                    type={"text"}
                    placeholder={"발급수량(최대 500개)"}
                    style={{
                      width: "338px",
                    }}
                    value={annualStock}
                    onChange={(e) => {
                      setAnnualStock(e.target.value);
                    }}
                    maxLength={3}
                  />
                  <CheckboxWrapper
                    onClick={() => {
                      setAnnualOutStock(!annualOutStock);
                    }}
                  >
                    <Checkbox
                      style={{
                        backgroundColor: "transparent",
                      }}
                      checked={annualOutStock}
                      onChange={() => {
                        setAnnualOutStock(!annualOutStock);
                      }}
                    />
                    <CheckboxText>품절 처리</CheckboxText>
                  </CheckboxWrapper>
                </div>
              </div>
            </div>

            {/* 평생 수강권 가격 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                padding: "21px 0px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                }}
              >
                <ProductItemTitle>평생 수강권 가격</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <MainInput
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "338px",
                      textAlign: "right",
                    }}
                    value={lifetimePrice}
                    onChange={(e) => {
                      setLifetimePrice(e.target.value);
                    }}
                  />

                  <CheckboxWrapper
                    style={{
                      margin: "12px 0px",
                    }}
                    onClick={() => {
                      setLifetimeIsSale(!lifetimeIsSale);
                    }}
                  >
                    <Checkbox
                      style={{
                        backgroundColor: "transparent",
                      }}
                      checked={lifetimeIsSale}
                      onChange={() => {
                        setLifetimeIsSale(!lifetimeIsSale);
                      }}
                    />
                    <CheckboxText>할인 사용</CheckboxText>
                  </CheckboxWrapper>
                </div>
              </div>

              {/* 할인율 */}
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                  marginTop: 19,
                }}
              >
                <ProductItemTitle>할인율</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <MainInput
                    disabled={!lifetimeIsSale}
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "93px",
                      textAlign: "right",
                    }}
                    value={lifetimeSale}
                    onChange={(e) => {
                      setLifetimeSale(e.target.value);
                    }}
                    maxLength={3}
                  />
                  <ProductItemTitle
                    style={{
                      width: "fit-content",
                      marginTop: 0,
                    }}
                  >
                    %
                  </ProductItemTitle>
                </div>
              </div>

              {/* 실 판매 가격 */}
              <div
                style={{
                  width: "100%",
                  height: "fit-content",
                  display: "flex",
                  marginTop: 19,
                }}
              >
                <ProductItemTitle>실 판매 가격</ProductItemTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <MainInput
                      type={"text"}
                      disabled={true}
                      placeholder={"0"}
                      style={{
                        width: "338px",
                        textAlign: "right",
                      }}
                      value={lifetimeRealPrice}
                      onChange={(e) => {}}
                    />
                    <div
                      style={{
                        width: 12,
                      }}
                    />
                    <ProductItemTitle
                      style={{
                        width: "fit-content",
                        marginTop: 0,
                      }}
                    >
                      월
                    </ProductItemTitle>

                    <MainInput
                      type={"text"}
                      disabled={true}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={lifetimeMonthPrice}
                      onChange={(e) => {}}
                    />
                    <ProductItemTitle
                      style={{
                        width: "fit-content",
                        marginTop: 0,
                      }}
                    >
                      원
                    </ProductItemTitle>
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: "13px",
                        lineHeight: "18.75px",
                        color: "rgba(181, 181, 181, 0.5)",
                        marginLeft: "4px",
                      }}
                    >
                      *실 판매금액/12개월
                    </PretendardText>
                  </div>

                  <MainInput
                    type={"text"}
                    placeholder={"발급수량(최대 500개)"}
                    style={{
                      width: "338px",
                    }}
                    value={lifetimeStock}
                    onChange={(e) => {
                      setLifetimeStock(e.target.value);
                    }}
                    maxLength={3}
                  />
                  <CheckboxWrapper
                    onClick={() => {
                      setLifetimeOutStock(!lifetimeOutStock);
                    }}
                  >
                    <Checkbox
                      style={{
                        backgroundColor: "transparent",
                      }}
                      checked={lifetimeOutStock}
                      onChange={() => {
                        setLifetimeOutStock(!lifetimeOutStock);
                      }}
                    />
                    <CheckboxText>품절 처리</CheckboxText>
                  </CheckboxWrapper>
                </div>
              </div>
            </div>

            {/* 기간 */}
            <ProductItemWrapper>
              <ProductItemTitle>기간</ProductItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <DateInput
                    value={moment(startDate).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                    }}
                  />
                  <span
                    style={{
                      width: 6,
                      height: 1,
                      backgroundColor: "rgba(181, 181, 181, 0.5)",
                    }}
                  />
                  <DateInput
                    value={moment(endDate).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                    }}
                  />
                </div>
                <CheckboxWrapper
                  onClick={() => {
                    if (noPeriodLimit) {
                      setEndDate(null);
                    }

                    setNoPeriodLimit(!noPeriodLimit);
                  }}
                >
                  <Checkbox
                    style={{
                      backgroundColor: "transparent",
                    }}
                    checked={noPeriodLimit}
                    onChange={() => {
                      if (noPeriodLimit) {
                        setEndDate(null);
                      }

                      setNoPeriodLimit(!noPeriodLimit);
                    }}
                  />
                  <CheckboxText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    기간 제한 없음
                  </CheckboxText>
                </CheckboxWrapper>
              </div>
            </ProductItemWrapper>
          </SettingContainer>
          <SaveBtnWrapper>
            <BasicBtn
              onClick={() => {
                editProductFunc();
              }}
            >
              저장하기
            </BasicBtn>
          </SaveBtnWrapper>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default ShoppingMembershipProductEdit;

const SettingContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const ProductItemWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  padding: 21px 0px;
`;

const ProductItemTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
  margin-top: 12px;
`;

const SaveBtnWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 79px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 70px;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;

  cursor: pointer;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
